// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN =
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    'https://cf9f47fd6f8e6007d1a92edba8f7e208@o4508681431613440.ingest.de.sentry.io/4508681474080848';

Sentry.init({
    dsn: SENTRY_DSN,
    // next.config.js sets ENV to dev | staging | prod from the build phase and
    // branch. The SDK default is NODE_ENV, which is 'production' for staging too.
    environment: process.env.ENV,
    // Logs every event the SDK sends or drops to the console under `next dev`.
    debug: process.env.NODE_ENV === 'development',
    tracesSampleRate: 1.0,
});
